import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Table, Popconfirm, message, LocaleProvider } from 'antd';
import ui from '../../lang/ui.json';
import s from './Groups.css';
import { Link } from 'react-router-dom';
import {fetchDecode} from '../../fetchUtils';
import { withRouter } from "react-router-dom";

class Groups extends React.Component {
  static propTypes = {
    locale: PropTypes.objectOf(PropTypes.string).isRequired,
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      config: require('Config'),
    };
  }

  componentDidMount() {
    fetchDecode(this.state.config.serverUrl + `groups/all`, message)
      .then(jsonGroupList => this.setState({ data: jsonGroupList }));
  }

  successMessage = () => {
    message.success(this.props.locale.messageSuccess, 2);
  };

  errorMessage = (error) => {
    message.error(`${this.props.locale.messageError} ${error}`, 5);
  };

  deleteFromTable = (row) => {
    const dataSource = this.state.data;
    const index = dataSource.findIndex(data => data.id === row);
    dataSource.splice(index, 1);
    this.setState({ data: dataSource });
  };

  deleteGroup = (id) => {
    fetch(this.state.config.serverUrl + `groups/${id}`,
      {
        method: 'DELETE',
        headers: new Headers({
            'Authorization': `Bearer ${sessionStorage.getItem("authenticationtoken")}`,
            'Content-Type': 'application/json',
            'username': `${sessionStorage.getItem('username')}`
        })
      },
    ).then((response) => {
      if (response.status === 204) {
        this.successMessage();
        this.deleteFromTable(id);
      } else {
        this.errorMessage(response.statusText);
      }
    });
  };

  render() {
    const columns = [{
      title: this.props.locale.tableName,
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      },
      render: (text, group) => <Link to={`groups/${group.id}`}>{text}</Link>,
    }, {
      title: this.props.locale.tableMembers,
      dataIndex: 'members',
      key: 'members',
      sorter: (a, b) => {
        if (a.members < b.members) return -1;
        if (a.members > b.members) return 1;
        return 0;
      },
    }, {
      title: '',
      key: 'id',
      dataIndex: 'id',
      width: 30,
      render: id => (
        <Popconfirm
          title={this.props.locale.confirm}
          onConfirm={() => this.deleteGroup(id)}
        >
          <Icon type="close-circle-o" className={s.delete} />
        </Popconfirm>
      ),
    }];
    return (
      <LocaleProvider locale={ui}>
        <div className={s.root}>
          <div className={s.headline}>
            <h1>{this.props.locale.title}</h1>
            <div className={s.headline_cont}>
              <Link to="add_new_group" className={s.headline__btn}>
                <Icon className={s.headline__icon} type="plus-circle-o" />
                {this.props.locale.button}
              </Link>
            </div>
          </div>
          <Table
            locale={{emptyText: 'Enginn hópur hefur verið búinn til'}}
            className={s.table}
            columns={columns}
            dataSource={this.state.data}
            rowKey={r => r.name}

          />
        </div>
      </LocaleProvider>
    );
  }
}

export default (Groups);




// WEBPACK FOOTER //
// ./src/routes/groups/Groups.js